import React from 'react';
import { Star, Quote } from 'lucide-react';
export function Testimonials() {
  const reviews = [{
    name: 'Michael R.',
    location: 'Macomb, MI',
    text: 'Moceri replaced our old shingle roof in two days. The crew was professional, the price matched the quote exactly, and the cleanup was immaculate. Highly recommend!'
  }, {
    name: 'Sarah T.',
    location: 'Troy, MI',
    text: 'After getting ghosted by two other contractors, Moceri was a breath of fresh air. Showed up on time, gave a fair quote, and the new shingle roof looks fantastic on our colonial.'
  }, {
    name: 'David L.',
    location: 'Sterling Heights, MI',
    text: 'Quality work from start to finish. They explained everything, helped us pick the right shingle color, and got it done before winter hit. No more ice dam issues!'
  }];
  return <section className="bg-slate-50 py-20 sm:py-24" data-id="element-243">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-244">
        <div className="text-center max-w-3xl mx-auto mb-14" data-id="element-245">
          <span className="inline-block text-[#2DB8E0] font-bold uppercase tracking-wider text-sm mb-4" data-id="element-246">
            Reviews
          </span>
          <h2 className="font-display italic text-4xl sm:text-5xl text-[#1a2332] leading-tight mb-4" data-id="element-247">
            Trusted by Michigan Homeowners
          </h2>
          <div className="flex justify-center items-center gap-2 text-yellow-400" data-id="element-248">
            {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-5 h-5 fill-current" data-id="element-249" />)}
            <span className="ml-2 text-slate-700 font-semibold" data-id="element-250">
              5.0 average rating
            </span>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-251">
          {reviews.map(r => <div key={r.name} className="bg-white rounded-xl p-7 shadow-sm border border-slate-100 relative" data-id="element-252">
              <Quote className="absolute top-5 right-5 w-8 h-8 text-[#2DB8E0]/20" data-id="element-253" />
              <div className="flex text-yellow-400 mb-4" data-id="element-254">
                {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-4 h-4 fill-current" data-id="element-255" />)}
              </div>
              <p className="text-slate-700 mb-6 leading-relaxed" data-id="element-256">"{r.text}"</p>
              <div className="flex items-center gap-3 pt-4 border-t border-slate-100" data-id="element-257">
                <div className="w-10 h-10 bg-[#2DB8E0]/10 rounded-full flex items-center justify-center font-bold text-[#1a9cc4]" data-id="element-258">
                  {r.name.charAt(0)}
                </div>
                <div data-id="element-259">
                  <div className="font-bold text-[#1a2332]" data-id="element-260">{r.name}</div>
                  <div className="text-sm text-slate-500" data-id="element-261">{r.location}</div>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}